import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Header = () => {
  const { user, logout } = useAuth();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isDropdownOpen && !event.target.closest('.dropdown')) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isDropdownOpen]);

  const toggleDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <>
      {/* Start - nav */}
      <div
        className="form-inline my-2 my-lg-0 bg-light"
        id="removeLayoutHeader"
        style={{
          backgroundImage: 'url(/assets/images/banner2-2.jpg)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }}
      >
        <div className="">
          <a className="navbar-brand" href="#">
            <img src="/assets/images/logo-ar-black.png" alt="" className="nav-img" />
          </a>
        </div>
        <div className="site-name" id="sitename">
          <h4 style={{ textAlign: 'center' }}>
            مبادرة السيد رئيس الجمهورية لفحص المقبلين على الزواج
          </h4>
        </div>
        <div className="col-md-2">
          <img style={{ width: '100%' }} src="/assets/images/100Million.png" id="100million" alt="100 مليون صحة" />
        </div>
      </div>
      <nav className="navbar navbar-expand-lg navbar-light custom-bg-info" dir="rtl">
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/prenup/PreMarriageSheet/MarriageIndex?IsPrint=True">
                طباعة
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/prenup/PreMarriageSheet/MarriageIndex?IsPrint=False">
                استعلام
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/prenup/PreMarriageSheet/Create">
                تسجيل استمارة
              </Link>
            </li>
            <li className="nav-item dropdown">
              <a
                href="#"
                className="dropdown-toggle nav-link"
                onClick={toggleDropdown}
                role="button"
                aria-haspopup="true"
                aria-expanded={isDropdownOpen}
              >
                <span className="text" style={{ fontWeight: 600 }}>
                  مرحباً {user?.username} / {user?.fullName} <i className="fa fa-user" aria-hidden="true"></i>
                </span>
              </a>
              <ul className={`dropdown-menu ${isDropdownOpen ? 'show' : ''}`}>
                <li className="nav-item">
                  <Link className="nav-link" style={{ fontSize: '14px' }} to="/prenup/SystemUser/ChangePassword">
                    تغيير كلمة المرور
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" style={{ color: '#000 !important', fontSize: '14px' }} to="/prenup/SystemUser/Logout">
                    تسجيل الخروج
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
      {/* End - nav */}
    </>
  );
};

export default Header;
